import { makeStyles } from 'tss-react/mui';

const useStylesChartGanttZoomBlock: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  chartGanttZoomBlock: {
    width: '100%',
    backgroundColor: theme.palette.background.default,
    borderLeft: `1px solid ${theme.palette.info.main}`,
    borderRight: `1px solid ${theme.palette.info.main}`,
  },
  chartGanttZoomBlockLabel: {
    marginLeft: 10,
    marginRight: 10,
  },
  chartGanttZoomBlockFieldSelect: {
    minWidth: '190px !important',
  },
}));

export default useStylesChartGanttZoomBlock;
